import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { cn } from '@/shared/lib/cn';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 min-h-[var(--unity-hit-target)]', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground hover:opacity-90',
            secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
            outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
            ghost: 'hover:bg-accent hover:text-accent-foreground',
            destructive: 'bg-destructive text-destructive-foreground hover:opacity-90',
        },
        size: {
            default: 'h-11 px-4 py-2',
            sm: 'h-9 rounded-md px-3',
            lg: 'h-12 rounded-md px-8',
            icon: 'h-11 w-11',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});
export function Button({ className, variant, size, type = 'button', ...props }) {
    return (_jsx("button", { type: type, className: cn(buttonVariants({ variant, size, className })), ...props }));
}
